import { HygraphImageProps } from '@/components/hygraph-image';

import { PressCardImageProps } from '@/features/press/components/press-card';

export const generatePressCardImage = (
  logoImage?: PressCardImageProps | undefined | null
): HygraphImageProps | undefined => {
  if (!logoImage) return undefined;

  const pressCardImage: HygraphImageProps = {
    url: logoImage.url,
    description: logoImage.description,
    height: logoImage.height,
    width: logoImage.width,
    imgClassName: logoImage.className,
  };

  return pressCardImage;
};
